import { Box, Button, Typography } from "@mui/material";
import ConfirmDialog from "components/common/ConfirmDialog";
import CustomButton from "components/common/CustomButton";
import { useState } from "react";
import { usePendingChanges } from "./PendingChangesContext";

/**
 * Sticky footer of the Settings tab, visible while changes are staged:
 * count + Discard all + Review & Save. Pinned to the bottom edge of the
 * Settings scroll container.
 */
export default function PendingSaveBar({ onReview }: { onReview: () => void }) {
  const { count, clear } = usePendingChanges();
  const [confirmDiscard, setConfirmDiscard] = useState(false);

  if (count === 0) return null;

  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 3,
        mt: "auto",
        bgcolor: "background.paper",
        borderTop: 1,
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2,
        py: 1,
      }}
    >
      <Typography variant="body2" fontWeight={600}>
        {count} unsaved change{count === 1 ? "" : "s"}
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      <Button
        size="small"
        color="error"
        sx={{ textTransform: "none" }}
        onClick={() => setConfirmDiscard(true)}
      >
        Discard all
      </Button>
      <CustomButton fullWidth={false} onClick={onReview}>
        Review & Save
      </CustomButton>

      <ConfirmDialog
        open={confirmDiscard}
        title="Discard pending changes?"
        message={`Discard ${count} pending change${
          count === 1 ? "" : "s"
        }? All controls revert to their saved values.`}
        confirmLabel="Discard"
        onConfirm={() => {
          clear();
          setConfirmDiscard(false);
        }}
        onCancel={() => setConfirmDiscard(false)}
      />
    </Box>
  );
}
